import { mediaUrl } from "../../lib/api";
import { useLang } from "../../context/LanguageContext";
import { ArrowRight, ArrowUpRight } from "lucide-react";

export function FinalCTA({ course, onInfo, onEnroll }) {
  const { t } = useLang();
  const bg = course.gallery?.[3] || course.hero_image;
  return (
    <section data-testid="course-final-cta" className="relative isolate overflow-hidden">
      <img src={mediaUrl(bg)} alt="" className="absolute inset-0 w-full h-full object-cover" />
      <div className="absolute inset-0 bg-[#0B1220]/70" />
      <div className="relative px-6 md:px-12 max-w-[1100px] mx-auto py-28 md:py-40 text-center">
        <h2 className="font-heading text-4xl sm:text-5xl lg:text-6xl font-light tracking-tight text-[#F4F8FF] leading-[1.05]">
          {t("finalcta.title")}
        </h2>
        <div className="mt-10 flex flex-col sm:flex-row justify-center gap-4">
          <button
            data-testid="final-info-btn"
            onClick={onInfo}
            className="group bg-[#F4F8FF] text-[#0B1220] hover:bg-[#5B9DFF] transition-colors rounded-sm px-8 py-4 text-sm font-medium tracking-wide flex items-center justify-center gap-2"
          >
            {t("common.request_info")}
            <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
          </button>
          <button
            data-testid="final-enroll-btn"
            onClick={onEnroll}
            className="group border border-[#F4F8FF] text-[#F4F8FF] hover:bg-[#F4F8FF] hover:text-[#0B1220] transition-colors rounded-sm px-8 py-4 text-sm font-medium tracking-wide flex items-center justify-center gap-2"
          >
            {t("common.enroll_online")}
            <ArrowUpRight className="h-4 w-4" />
          </button>
        </div>
      </div>
    </section>
  );
}
